<template>
  <div>
    <Fontnavbar title="拼团" />
    <!-- 收货人地址 -->
    <div class="order-address" @click="goPage('/user/address/index?select=true&address_id=' + chosenAddressId)" v-if="chosenAddressId != 0">
      <van-cell :title="address.user_name + ' ' + address.user_phone" icon="location-o" center value="" is-link :label="address.address" />
    </div>
    <div class="order-address" @click="goPage('/user/address/index?select=true')" v-else>
      <van-cell title="请选择收货地址" icon="location-o" is-link />
    </div>

    <!-- 商品 -->
    <div class="order-goods">
      <van-card :num="goodsNum" :price="goods.goods_price" :title="goods.goods_name" :thumb="imgDomain + goods.goods_thumb_path" />
    </div>

    <!-- 支付方式 -->
    <div class="order-type">
      <van-cell>
        <template slot="title">
          <van-tag type="danger">必选</van-tag>
          <span class="custom-title"> 支付方式</span>
        </template>
      </van-cell>
      <div class="order-type-radio">
        <van-radio-group v-model="payType" @change="changePay" checked-color="#07c160" icon-size="14px">
          <div v-for="(item, i) in payList" :key="i">
            <van-radio :name="item.id">{{ item.pay_name }}
              <span class="tip"><br />账号：{{ item.account }}<br />户名：{{ item.username }}</span>
            </van-radio>
          </div>
        </van-radio-group>
      </div>
    </div>

    <!-- 备注留言 -->
    <div class="order-type mb-70">
      <van-field v-model="remark" rows="2" autosize label="留言" type="textarea" maxlength="50" placeholder="请输入留言" show-word-limit @input="setRemark" />
    </div>


    <div class="order-sum">
      <div>商品价格：￥{{ goods.goods_price }}</div>
      <div class="order-sum-price">
        总价：<span>￥{{ goods.goods_price * goodsNum }}</span>
        <br>
      </div>
      <van-image width="100%" src="/static/m_order_tip.jpg" />
      <div class="bottom">
        <van-button round block type="danger" @click="submitOrder">提交订单</van-button>
      </div>
    </div>

  </div>
</template>

<script>
import {
    joinAfterGroupBuy,
    joinGroupBuy
} from '../../../api.js'
import Fontnavbar from '../../../components/Navbar.vue'
import { post } from '../../../request.js'
import {
  Cell,
  Card,
  Button,
  Tag,
  RadioGroup,
  Radio,
  Field,
  SubmitBar,
  Toast,
  Icon,
  Image,
  ActionSheet,
  Checkbox,
  CheckboxGroup,
  Divider,
  Stepper,
  Col,
  Row,
  CouponCell,
  CouponList,
  Popup,
} from 'vant'

export default {
  components: {
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Tag.name]: Tag,
    [Field.name]: Field,
    [SubmitBar.name]: SubmitBar,
    [Card.name]: Card,
    [Button.name]: Button,
    [Image.name]: Image,
    Fontnavbar,
    [ActionSheet.name]: ActionSheet,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Divider.name]: Divider,
    [Stepper.name]: Stepper,
    [Col.name]: Col,
    [Row.name]: Row,
    [CouponCell.name]: CouponCell,
    [CouponList.name]: CouponList,
    [Popup.name]: Popup,
  },

  data () {
    return {
      imgDomain: process.env.VUE_APP_IMG_URL, // oss图片地址
      loading: false,
      logisticId: 0,
      logisticList: [],
      payType: 0,
      payList: [],
      goods: [],
      remark: '',
      goodsId:0,
      goodsNum:0,
      sn:0,
    }
  },


  created () {
      // console.log('created',this.$route.query)
      this.goodsId = this.$route.query.goods_id ? this.$route.query.goods_id : 0
      this.goodsNum = this.$route.query.goods_num ? this.$route.query.goods_num : 1
      this.sn = this.$route.query.sn ? this.$route.query.sn : ''
      this.loadData();
  },
  computed: {

    address () {
      return this.$store.state.user.userAddress
    },
    chosenAddressId () {
      return this.$store.state.user.userAddress.id
        ? this.$store.state.user.userAddress.id
        : 0
    }
  },

  methods: {
    // 首次进去加载数据
    loadData () {
      var loading = Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
      })
      var that = this

      post(joinAfterGroupBuy, { goods_id: that.goodsId }).then((res) => {
        loading.clear()

        if (res.code == 200) {
          // 收货地址处理
          if (res.data.address.length != 0) {
            var address = {}
            if (this.address && this.address.id) {
              address = this.address
            } else {
              address.id = res.data.address[0].id
              address.user_name = res.data.address[0].user_name
              address.user_phone = res.data.address[0].user_phone
              address.address =
                res.data.address[0].province +
                res.data.address[0].city +
                res.data.address[0].district +
                res.data.address[0].address
                that.$store.commit('setUserAddress', address)
            }
            // console.log(address)
          }
          // 订单商品
          that.goods = res.data.goods_info
          // 支付方式
          that.payList = res.data.pay_list
          if (res.data.pay_list.length == 1) {
            that.payType = res.data.pay_list[0].id
          }
          // 相关价格
          that.goodsWeight = res.data.goods_weight
          that.goodsPrice = res.data.goods_price
          that.totalPrice = res.data.total_price
        } else if (res.code == 201) {
          this.$router.replace({ path: '/user/login' })
        }
      })
    },
    goPage (path) {
      this.$router.push({ path: path })
    },
    // 改变物流
    changeLogistic (name) {
      this.logisticId = name
      for (var key in this.logisticList) {
        if (name == this.logisticList[key].id) {
          this.freight = this.logisticList[key].freight
          break
        }
      }
    },
    changePay (name) {
      this.payType = name
    },
    setRemark (value) {
      this.remark = value
    },
    // 提交订单
    submitOrder () {
      var that = this
      if (that.chosenAddressId == 0) {
        Toast('请选择收货地址')
        return false
      }
      if (that.payType == 0) {
        Toast('请选择支付方式')
        return false
      }
      var loading = Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0,
      })
      var param = {
          goods_id: that.goodsId,
          address_id: that.chosenAddressId,
          buy_num: that.goodsNum,
          pay_id: that.payType,
          remark: that.remark,
          part_sn: that.sn,
      }
      // if (param){
      //     console.log(param)
      //     loading.clear()
      //     return false
      // }
      post(joinGroupBuy, param).then((res) => {
        loading.clear()
        if (res.code == 200) {
          that.$router.push({
            path: '/order/results',
            query: { order_no: res.data },
          })
        } else if (res.code == 210) {
          if ((res.pay_type == 'alipay')) {
            //   支付宝支付
            const div = document.createElement('div')
            /* 此处form就是后台返回接收到的数据 */
            div.innerHTML = res.pay_info
            document.body.appendChild(div)
            document.forms[0].submit()
          } else {
            // 微信支付
            if (res.pay_info.mweb_url) {
              window.location.href = res.pay_info.mweb_url
            }
            res.pay_info.response.part_sn  = res.part_sn
            that.wx_response = res.pay_info.response
            that.weixinPay(res.pay_info.response)
          }
        } else {
          Toast(res.msg)
        }
      })
    },
    //解决微信内置对象报错
    weixinPay (data) {
      var that = this
      if (typeof WeixinJSBridge == 'undefined') {
        if (document.addEventListener) {
          document.addEventListener(
            'WeixinJSBridgeReady',
            that.onBridgeReady(data),
            false
          )
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', that.onBridgeReady(data))
          document.attachEvent(
            'onWeixinJSBridgeReady',
            that.onBridgeReady(data)
          )
        }
      } else {
        that.onBridgeReady()
      }
    },

    //微信内置浏览器类，weChatParameter对象中的参数是3.步骤代码中从后端获取的数据
    onBridgeReady () {
      var that = this
      // eslint-disable-next-line no-undef
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        that.wx_response,
        function (res) {
          // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          if (res.err_msg == 'get_brand_wcpay_request:ok') {
            Toast({
              message: '支付成功',
              position: 'middle',
              duration: 3000,
            })
            that.number = null
            that.$router.push({
              path: '/goods/groupBuy/orderDetail?sn=' + that.wx_response.part_sn,
            })
          } else {
            Toast({
              message: '支付失败',
              position: 'middle',
              duration: 3000,
            })
            that.$router.push({
              path: '/order/order',
            })
          }
        }
      )
    },
  },

}
</script>

<style lang="less" scoped>
.order-address {
  margin-bottom: 10px;
}
.points-tag {
  margin: 10px auto;
}
.order-goods {
  background-color: #ffffff;
  margin-bottom: 10px;
}
.order-goods .van-card {
  background-color: #ffffff;
  border-bottom: 1px solid #f8f8f8;
}
.order-type {
  background-color: #ffffff;
}
.order-type-radio {
  padding: 10px;
  font-size: 14px;
  margin-bottom: 10px;
}
.van-radio {
  margin-bottom: 10px;
}
.van-radio .tip {
  color: #999999;
}
.mb-70 {
  margin-bottom: 10px;
}
.order-sum {
  padding: 15px;
  background-color: #ffffff;
  font-size: 14px;
  color: #333333;
  line-height: 24px;
  text-align: right;
}
.order-sum-price {
  font-size: 16px;
  margin-bottom: 15px;
}
.order-sum-price span {
  color: #ff0000;
}
.order-sum .bottom {
  display: flex;
  justify-content: space-between;
}
</style>
